module.exports = __webpack_public_path__ + "static/media/mail.aa4d2232.svg";